import { createSelector } from '@reduxjs/toolkit'

import { translate } from '@/utils/translations'

export const isRecommendingRegionSelector = createSelector(
  [state => state.regionRecommendation.key],
  regionRecommendationKey => Boolean(regionRecommendationKey)
)

export const recommendedRegionSelector = createSelector(
  [
    state => state.activeRegions,
    state => state.regionRecommendation.key
  ],
  (region, key) => region[key]
)

export const recommendedRegionTextSelector = createSelector(
  [recommendedRegionSelector],
  ({ displayName }) => {
    const regionsRequiringAnArticle = ['United States', 'United Kingdom']

    const translationKey = regionsRequiringAnArticle.includes(displayName)
      ? 'regions.recommendation_text_with_article'
      : 'regions.recommendation_text'

    return translate(translationKey, { country: displayName })
  }
)
